module.exports = __webpack_public_path__ + "img/33.4.NH3-N.804b2729.png";